module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="' +
((__t = (id)) == null ? '' : __t) +
'" class="' +
((__t = (dialogClass)) == null ? '' : __t) +
' modal" role="dialog" style="display:block;position:fixed;pointer-events: none;">\n    <!--<div class="modal-dialog" role="document" style="position:absolute;left:50%;top:50%;-webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%);pointer-events: none;">-->\n    <div class="modal-dialog" role="document">\n        <!-- Modal content-->\n        <div class="modal-content" style="pointer-events:auto;">\n            <form id="' +
((__t = (id)) == null ? '' : __t) +
'_formDialog" class="' +
((__t = (formClass)) == null ? '' : __t) +
'">\n                <div class="modal-header">\n                    <h4 class="DescartesModalTitle modal-title">' +
((__t = (title)) == null ? '' : __t) +
'</h4>\n                    <button id="' +
((__t = (id)) == null ? '' : __t) +
'_close" type="button" class="close" data-dismiss="modal" aria-label="Close">\n                        <span aria-hidden="true">&times;</span>\n                    </button>\n                </div>\n                <div class="modal-body">\n                    ' +
((__t = (content)) == null ? '' : __t) +
'\n                </div>\n                <div class="modal-footer">\n                	';
 if(useDropMenuActions) { ;
__p += '\n                       <div class="dropup">\n                         <button class="btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
' dropdown-toggle" type="button" id="' +
((__t = (id)) == null ? '' : __t) +
'_dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="' +
((__t = (dropMenuLabelTooltip)) == null ? '' : __t) +
'">\n                            ' +
((__t = (dropMenuLabel)) == null ? '' : __t) +
'\n                         </button>\n                         <div class="dropdown-menu" aria-labelledby="' +
((__t = (id)) == null ? '' : __t) +
'_dropdownMenu">\n                            <button class="dropdown-item" type="button" id="' +
((__t = (id)) == null ? '' : __t) +
'_addSelectionLayerAction" title="' +
((__t = (dropMenuBtnAddLabelTooltip)) == null ? '' : __t) +
'">' +
((__t = (dropMenuBtnAddLabel)) == null ? '' : __t) +
'</button>\n                            <button class="dropdown-item" type="button" id="' +
((__t = (id)) == null ? '' : __t) +
'_fixSelectionLayerAction" title="' +
((__t = (dropMenuBtnFixLabelTooltip)) == null ? '' : __t) +
'">' +
((__t = (dropMenuBtnFixLabel)) == null ? '' : __t) +
'</button>\n                            <button class="dropdown-item" type="button" id="' +
((__t = (id)) == null ? '' : __t) +
'_flashSelectionLayerAction" title="' +
((__t = (dropMenuBtnFlashLabelTooltip)) == null ? '' : __t) +
'">' +
((__t = (dropMenuBtnFlashLabel)) == null ? '' : __t) +
'</button>\n                            <button class="dropdown-item" type="button" id="' +
((__t = (id)) == null ? '' : __t) +
'_undisplaySelectionLayerAction" title="' +
((__t = (dropMenuBtnUndisplayLabelTooltip)) == null ? '' : __t) +
'">' +
((__t = (dropMenuBtnUndisplayLabel)) == null ? '' : __t) +
'</button>\n                            <button class="dropdown-item" type="button" id="' +
((__t = (id)) == null ? '' : __t) +
'_unselectRequestAction" title="' +
((__t = (dropMenuBtnUnselectLabelTooltip)) == null ? '' : __t) +
'">' +
((__t = (dropMenuBtnUnselectLabel)) == null ? '' : __t) +
'</button>\n                         </div>\n                      </div>\n                    ';
 };
__p += '\n                    <button type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">' +
((__t = (sendLabel)) == null ? '' : __t) +
'</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/ResultFormDialog.ejs
// module id = 313
// module chunks = 0